import { useQuery } from '@tanstack/react-query'

import { get } from 'utils/http'

import { useCustomerId } from './useCustomerId'

export const useWeeklyReportsCredits = () => {
  const customerId = useCustomerId()

  const getCredits = () => get(`/customers/${customerId}/weeklyReports/credits`)

  const { data, isLoading, isError } = useQuery({
    queryKey: ['weeklyReportsCredits', customerId],
    queryFn: getCredits,
  })

  return {
    credits: data,
    isLoading,
    isError,
  }
}
